module.exports = __webpack_public_path__ + "img/form.40feeb2a.svg";